import {
  RoleKey_enum,
  UserRoleAssignedToFragment as UserRole,
} from '../../graphql/hasura/generated';
import { UserModel } from '../User/model';

interface IRenderUserRoleAssignedToOptions {
  toString: boolean;
}

function renderUserRoleAssignedTo(
  userRole: UserRole,
  { toString }: IRenderUserRoleAssignedToOptions,
) {
  const { assignedToUser, role, sourceId, nickname } = userRole;

  if (assignedToUser) {
    return toString
      ? (UserModel.labels.getLabel(assignedToUser) || '')
      : UserModel.routes.renderRowLink(assignedToUser);
  }

  if (role.key === RoleKey_enum.RESIDENT && sourceId) {
    return 'NOT SYNCHRONIZED'; // PMS Sync
  }

  if (nickname) {
    return nickname; // Guest Pass or Guest PIN
  }

  if (role.key === RoleKey_enum.GUEST_PROPERTY_KEY) {
    return 'Anonymous Guest'; // Callbox killer
  }

  return 'UNASSIGNED';
}

export function renderUserRoleAssignedToString(userRole: UserRole): string {
  return renderUserRoleAssignedTo(userRole, { toString: true }) as string;
}

export function renderUserRoleAssignedToLink(userRole: UserRole) {
  return renderUserRoleAssignedTo(userRole, { toString: false });
}
